import { Link } from "react-router-dom";
import { MapPin, ChevronDown, Store, ShieldCheck } from "lucide-react";
import { useApp } from "../context/AppContext";

export default function HeroSection() {
  const { t } = useApp();

  const scrollToVarieties = () => {
    document.getElementById("live-souq")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="hero" data-testid="hero-section">
      <div className="hero-bg" style={{ backgroundImage: "url(/images/hero.webp)" }} />
      <div className="hero-overlay" />
      <div className="hero-aurora" aria-hidden="true" />
      <div className="hero-content">
        <p className="hero-eyebrow">{t("hero.eyebrow")}</p>
        <h1 className="hero-title" data-testid="hero-title">{t("hero.title")}</h1>
        <p className="hero-sub" data-testid="hero-subtitle">{t("hero.subtitle")}</p>
        <div className="hero-ctas">
          <Link to="/map" className="btn-lux-gold" data-testid="hero-cta-map">
            <MapPin size={17} />
            {t("hero.cta_map")}
          </Link>
          <Link to="/souq" className="btn-lux-gold hero-cta-souq" data-testid="hero-cta-souq">
            <Store size={17} />
            {t("hero.cta_souq")}
          </Link>
          <Link to="/provenance" className="btn-lux-ghost" data-testid="hero-cta-watheeq">
            <ShieldCheck size={17} />
            {t("hero.cta_watheeq")}
          </Link>
        </div>
      </div>
      <button className="hero-scroll-hint" onClick={scrollToVarieties} data-testid="hero-scroll-hint">
        <span>{t("hero.scroll")}</span>
        <ChevronDown size={16} />
      </button>
    </section>
  );
}
